class Extension {
    id = null;

    type = null;

    container = null;

    constructor({ id, type, container }) {
        this.container = container;
        this.id = id;
        this.type = type;
    }

    async onLoad() {}

    async onUnload() {}

    async onSelect() {}

    async onDeselect() {}

    async onBlockSelect() {}

    async onBlockDeselect() {}
}

export default Extension;
